import { createFileRoute, redirect } from '@tanstack/react-router';

import { DEFAULT_REDIRECT_URL } from '@/constants';
import { Organizations } from '@/features/organizations';
import { createClientFromAuth } from '@/utils';

export const Route = createFileRoute('/_auth/organizations/')({
  component: Organizations,
  beforeLoad: async ({ context: { auth } }) => {
    const client = await createClientFromAuth(auth);
    const { organizations } = await client.listOrganizations();

    if (organizations.length < 1) {
      throw redirect({ to: '/organizations/new', search: { onboarding: true } });
    } else if (organizations.length === 1) {
      const org = organizations[0];
      const orgCode = await auth.getCurrentOrganization();
      if (orgCode !== org.code) {
        throw redirect({ to: '/login', search: { orgCode: org.code, redirect: DEFAULT_REDIRECT_URL } });
      } else {
        throw redirect({ to: DEFAULT_REDIRECT_URL });
      }
    }
  },
});
